import { TFunction } from "i18next"

export const TEXTO_TRIMESTRE = (t: TFunction) => ({
  1: t("taxSummary.firstTrimester"),
  2: t("taxSummary.secondTrimester"),
  3: t("taxSummary.thirdTrimester"),
  4: t("taxSummary.fourthTrimester"),
})
